import { render, staticRenderFns } from "./SnowpeakBundleProductTile.vue?vue&type=template&id=64115909&scoped=true&"
import script from "./SnowpeakBundleProductTile.vue?vue&type=script&lang=js&"
export * from "./SnowpeakBundleProductTile.vue?vue&type=script&lang=js&"
import style0 from "./SnowpeakBundleProductTile.vue?vue&type=style&index=0&id=64115909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64115909",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/owldesign/Sites/snowpeak/website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64115909')) {
      api.createRecord('64115909', component.options)
    } else {
      api.reload('64115909', component.options)
    }
    module.hot.accept("./SnowpeakBundleProductTile.vue?vue&type=template&id=64115909&scoped=true&", function () {
      api.rerender('64115909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "development/vue-components/SnowpeakBundleProductTile.vue"
export default component.exports